export const months = [
    {
        "monthEn": "January",
        "monthEs": "Enero",
        "monthNumber": "01"
    },
    {
        "monthEn": "February",
        "monthEs": "Febrero",
        "monthNumber": "02"
    },
    {
        "monthEn": "March",
        "monthEs": "Marzo",
        "monthNumber": "03"
    },
    {
        "monthEn": "April",
        "monthEs": "Abril",
        "monthNumber": "04"
    },
    {
        "monthEn": "May",
        "monthEs": "Mayo",
        "monthNumber": "05"
    },
    {
        "monthEn": "June",
        "monthEs": "Junio",
        "monthNumber": "06"
    },
    {
        "monthEn": "July",
        "monthEs": "Julio",
        "monthNumber": "07"
    },
    {
        "monthEn": "August",
        "monthEs": "Agosto",
        "monthNumber": "08"
    },
    {
        "monthEn": "September",
        "monthEs": "Septiembre",
        "monthNumber": "09"
    },
    {
        "monthEn": "October",
        "monthEs": "Octubre",
        "monthNumber": "10"
    },
    {
        "monthEn": "November",
        "monthEs": "Noviembre",
        "monthNumber": "11",
    },
    {
        "monthEn": "December",
        "monthEs": "Diciembre",
        "monthNumber": "12"
    }
];